export function EmptyState() {
  return (
    <tr>
      <td colSpan="4" className="px-6 py-12 text-center">
        <div className="text-gray-500 text-lg font-medium">No categories added yet</div>
        <p className="text-sm text-gray-400 mt-2">Add a category to start configuring objectives</p>
      </td>
    </tr>
  );
}